(function(EF, undefined) {
  var Questions = Backbone.Collection.extend({
    model: EF.Models.Question
  });

  _.extend(EF.Collections, {
    Questions: Questions
  });
})(EF);
